import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { Link } from "react-router-dom";
import { ChevronRight, X, FileText } from "lucide-react";

export default function KuisSiswa({ user }) {
  const [listKuis, setListKuis] = useState([]);
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    async function fetchKuis() {
      if (!user) return;
      const { data: siswaData } = await supabase
        .from("siswa")
        .select("id")
        .ilike("nama_lengkap", user.nama)
        .single();
      if (!siswaData) return;
      const { data } = await supabase
        .from("kuis_siswa")
        .select("*, kuis(*)")
        .eq("siswa_id", siswaData.id)
        .order("id", { ascending: false });
      setListKuis(data || []);
    }
    fetchKuis();
  }, [user]);

  return (
    <div
      style={{
        padding: "20px",
        maxWidth: "480px",
        margin: "0 auto",
        background: "#F8FAFC",
        minHeight: "100vh",
        fontFamily: "sans-serif",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "20px",
        }}
      >
        <Link to="/" style={{ color: "#64748B" }}>
          <ChevronRight size={24} style={{ transform: "rotate(180deg)" }} />
        </Link>
        <h2 style={{ margin: 0, color: "#1E293B" }}>Ujian & Kuis Saya</h2>
      </div>
      {listKuis.length === 0 && (
        <p style={{ textAlign: "center", color: "#94A3B8", marginTop: 50 }}>
          Belum ada kuis yang ditugaskan.
        </p>
      )}
      {listKuis.map((item) => (
        <div
          key={item.id}
          style={{
            background: "white",
            padding: "15px",
            borderRadius: "16px",
            marginBottom: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxShadow: "0 2px 5px rgba(0,0,0,0.03)",
            border: "1px solid #F1F5F9",
          }}
        >
          <div>
            <div
              style={{ fontWeight: "700", fontSize: "14px", color: "#334155" }}
            >
              {item.kuis?.judul}
            </div>
            <div style={{ fontSize: "12px", color: "#64748B", marginTop: 2 }}>
              {item.kuis?.mapel} • Oleh: {item.kuis?.pembuat}
            </div>
          </div>
          <button
            onClick={() => setPreviewUrl(item.kuis?.link_url)}
            style={{
              background: "#F5F3FF",
              color: "#7C3AED",
              border: "none",
              padding: "8px 12px",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              gap: 5,
              cursor: "pointer",
              fontWeight: "600",
              fontSize: "12px",
            }}
          >
            <FileText size={16} /> Kerjakan
          </button>
        </div>
      ))}
      {previewUrl && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(15, 23, 42, 0.9)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ position: "absolute", top: 20, right: 20 }}>
            <button
              onClick={() => setPreviewUrl(null)}
              style={{
                background: "white",
                border: "none",
                borderRadius: "50%",
                width: 40,
                height: 40,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <X size={24} color="#333" />
            </button>
          </div>
          <div
            style={{
              width: "90%",
              maxWidth: "800px",
              height: "85vh",
              background: "white",
              borderRadius: "16px",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <iframe
              src={previewUrl}
              title="Kuis"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
}
